import { useQuery } from '@tanstack/react-query';
import { queryCabinIssuesForWorkpacks } from '../../../services/api';
import { CabinIssue } from '../../../models/cabinIssues';

const useQueryCabinIssuesForWorkpacks = ({ id }: { id: string }):
  { data: CabinIssue[]; isLoading: boolean } => {
  const { data, isLoading } = useQuery({
    queryKey: ['queryCabinIssuesForWorkpacks', id],
    queryFn: () => {
      return queryCabinIssuesForWorkpacks({ aircraft_id: id });
    },
    enabled: !!id,
  });

  return { data, isLoading };
};

export default useQueryCabinIssuesForWorkpacks;

